// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"91c07b59","453":"f6f3b731"}[chunkId] + ".chunk.js";
};